import React from 'react';
import ProductCard from './ProductCard';
import '../styles/ProductSection.css';

const ProductSection = ({ id, title, products, description }) => {
  return (
    <section id={id} className="product-section section">
      <div className="container">
        <div className="section-title">
          <h2>{title}</h2>
          {description && <p className="section-description">{description}</p>}
        </div>

        {products.length === 0 ? (
          <div className="empty-state">
            <span className="empty-icon">🎂</span>
            <p>No products available yet. Check back soon!</p>
          </div>
        ) : (
          <div className="product-grid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductSection;
